"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
var __1 = require("../..");
var statistics_1 = require("./util/statistics");
var DeviceStatistics_1 = __importDefault(require("./DeviceStatistics"));
var DailyStatistics_1 = __importDefault(require("./DailyStatistics"));
var HeatMapStatistics_1 = __importDefault(require("./HeatMapStatistics"));
var devices_logo_svg_1 = __importDefault(require("./assets/devices-logo.svg"));
var chart_logo_new_svg_1 = __importDefault(require("./assets/chart-logo-new.svg"));
var chart_logo_svg_1 = __importDefault(require("./assets/chart-logo.svg"));
var traffic_logo_svg_1 = __importDefault(require("./assets/traffic-logo.svg"));
// import BetaTag from '../../../../../app/components/widgets/BetaTag'
var ga_1 = require("../../../../../app/util/ga");
var NoLinkAnalyticsGraphic_1 = __importDefault(require("./NoLinkAnalyticsGraphic"));
var useLinkAnalyticsStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        dialogTitleDiv: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: 116,
            marginBottom: 44,
        },
        copyLinkDiv: {
            display: 'flex',
        },
        copyIcon: {
            marginRight: 5,
        },
        linkAnalyticsTitle: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: 10,
        },
        linkAnalyticsDiv: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '60px',
        },
        linkAnalyticsText: {
            marginTop: 20,
            marginBottom: 20,
            textAlign: 'center',
        },
        titleText: {
            marginRight: 16,
        },
        subtitleText: {
            marginBottom: 20,
        },
        feedbackButton: (_a = {
                height: 44,
                width: '100%',
                maxWidth: '100%'
            },
            _a[theme.breakpoints.up('md')] = {
                maxWidth: 200,
            },
            _a),
    });
});
var useLinkStatisticsGraphsStyles = core_1.makeStyles(function () { return ({
    root: {
        margin: 20,
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
    },
}); });
function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index;
    return (react_1.default.createElement("div", { role: "tabpanel", hidden: value !== index, id: "full-width-tabpanel-" + index, "aria-labelledby": "full-width-tab-" + index }, value === index && react_1.default.createElement(core_1.Typography, null, children)));
}
var useStyles = core_1.makeStyles(function (theme) { return ({
    root: {
        marginTop: 20,
        marginBottom: 20,
    },
    tabRoot: {
        border: "solid 1px " + theme.palette.secondary.light,
        borderRadius: 3,
    },
    tabSection: {
        display: 'flex',
    },
    tabBar: {
        marginTop: 46,
        '& .MuiTabs-indicator': {
            backgroundColor: '#FFC700',
        },
    },
    tab: {
        display: 'flex',
        alignContent: 'center',
    },
    tabIcon: {
        width: 15,
        marginRight: 6.67,
    },
    tabIconDisabled: {
        width: 15,
        marginRight: 6.67,
        opacity: 0.7,
    },
    totalClicks: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
    },
    totalClicksMobile: {
        display: 'flex',
        alignItems: 'center',
    },
    totalClicksIcon: {
        height: 18,
        marginRight: 12,
    },
    totalClicksIconMobile: {
        width: 10.67,
        height: 12,
        marginRight: 7.67,
    },
    totalClicksText: {
        marginLeft: 0,
        marginRight: 39,
        alignSelf: 'center',
        color: theme.palette.primary.main,
    },
}); });
function Graphs(_a) {
    var data = _a.data, shortUrl = _a.shortUrl;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var classes = useStyles();
    var _c = __read(react_1.useState(0), 2), tabValue = _c[0], setTabValue = _c[1];
    // Map number to type for display
    var daMap = new Map();
    daMap.set(0, 'device');
    daMap.set(1, 'clicks');
    daMap.set(2, 'traffic');
    react_1.useEffect(function () {
        // Google Analytics: default device page and event on opening drawer
        ga_1.GAPageView('DEVICE PAGE');
        ga_1.GAEvent('drawer page analytics data', 'device', "/" + shortUrl);
        return function () {
            ga_1.GAPageView('USER PAGE');
        };
    }, []);
    var handleChange = function (_, newValue) {
        setTabValue(newValue);
        // Google Analytics: analytics data on device, clicks and traffics
        var daType = daMap.get(newValue) || 'DEVICE PAGE';
        ga_1.GAPageView(daType.toUpperCase() + " PAGE");
        ga_1.GAEvent('drawer page analytics data', daType, "/" + shortUrl);
    };
    var getIconStyle = function (index) {
        if (tabValue === index) {
            return classes.tabIcon;
        }
        return classes.tabIconDisabled;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Hidden, { mdUp: true },
            react_1.default.createElement("div", { className: classes.totalClicksMobile },
                react_1.default.createElement("img", { src: chart_logo_new_svg_1.default, className: classes.totalClicksIconMobile, alt: "clicks logo" }),
                react_1.default.createElement(core_1.Typography, { variant: "body2", color: "primary", className: classes.totalClicksText }, data.totalClicks + " " + t('editLink.totalClick')))),
        react_1.default.createElement("div", { className: classes.root },
            react_1.default.createElement("div", { className: classes.tabRoot },
                react_1.default.createElement("div", { className: classes.tabSection },
                    react_1.default.createElement(core_1.Tabs, { value: tabValue, onChange: handleChange, className: classes.tabBar },
                        react_1.default.createElement(core_1.Tab, { label: react_1.default.createElement("div", { className: classes.tab },
                                react_1.default.createElement("img", { src: devices_logo_svg_1.default, className: getIconStyle(0), alt: "devices logo" }),
                                ' ',
                                t('editLink.analytics.devices.title')) }),
                        react_1.default.createElement(core_1.Tab, { label: react_1.default.createElement("div", { className: classes.tab },
                                react_1.default.createElement("img", { src: chart_logo_svg_1.default, className: getIconStyle(1), alt: "clicks logo" }),
                                ' ',
                                t('editLink.analytics.click.title')) }),
                        react_1.default.createElement(core_1.Tab, { label: react_1.default.createElement("div", { className: classes.tab },
                                react_1.default.createElement("img", { src: traffic_logo_svg_1.default, className: getIconStyle(2), alt: "traffic logo" }),
                                ' ',
                                t('editLink.analytics.traffic.title')) })),
                    react_1.default.createElement(core_1.Hidden, { smDown: true },
                        react_1.default.createElement("div", { className: classes.totalClicks },
                            react_1.default.createElement("img", { src: chart_logo_new_svg_1.default, className: classes.totalClicksIcon, alt: "clicks logo" }),
                            react_1.default.createElement(core_1.Typography, { variant: "h6", className: classes.totalClicksText }, data.totalClicks + " " + t('editLink.totalClick'))))),
                react_1.default.createElement(core_1.Divider, null),
                react_1.default.createElement(TabPanel, { value: tabValue, index: 0 },
                    react_1.default.createElement(DeviceStatistics_1.default, { deviceClicks: data.deviceClicks })),
                react_1.default.createElement(TabPanel, { value: tabValue, index: 1 },
                    react_1.default.createElement(DailyStatistics_1.default, { dailyClicks: data.dailyClicks })),
                react_1.default.createElement(TabPanel, { value: tabValue, index: 2 },
                    react_1.default.createElement(HeatMapStatistics_1.default, { weekdayClicks: data.weekdayClicks }))))));
}
function LinkStatisticsGraphs() {
    var classes = useLinkStatisticsGraphsStyles();
    var shortUrl = __1.useDrawerState().relevantShortLink;
    var linkStatistics = statistics_1.useStatistics(shortUrl);
    // Still fetching link statistics.
    if (!linkStatistics.status) {
        return (react_1.default.createElement("div", { className: classes.root },
            react_1.default.createElement(core_1.CircularProgress, { className: classes.circularProgress })));
    }
    if (!linkStatistics.contents) {
        return react_1.default.createElement(NoLinkAnalyticsGraphic_1.default, null);
    }
    return react_1.default.createElement(Graphs, { data: linkStatistics.contents, shortUrl: shortUrl });
}
function LinkAnalytics() {
    var _a = __read(react_i18next_1.useTranslation(), 1), t = _a[0];
    var classes = useLinkAnalyticsStyles();
    return (react_1.default.createElement("div", { className: classes.linkAnalyticsDiv },
        react_1.default.createElement("div", { id: "link-analytics", className: classes.linkAnalyticsTitle },
            react_1.default.createElement(core_1.Typography, { className: classes.titleText, variant: "h3", color: "primary" }, t('editLink.analytics.title'))),
        react_1.default.createElement(core_1.Typography, { className: classes.subtitleText, variant: "body1", color: "primary" }, t('editLink.analytics.message')),
        react_1.default.createElement(LinkStatisticsGraphs, null)));
}
exports.default = LinkAnalytics;
